import styled from 'styled-components'

import Skeleton from 'react-loading-skeleton'
import { colors } from '../../../../styles/constants'
import { CustomButton } from '../../../../styles/global'

const CARD_BOX_SIZES = {
  title: {
    width: '190px',
    height: '17px',
    borderRadius: '8px',
    marginBottom: '4px'
  },
  subtitle: {
    width: '290px',
    height: '17px',
    borderRadius: '8px',
    marginBottom: '16px'
  },
  card: {
    width: '100%',
    height: '74px',
    borderRadius: '12px',
    marginBottom: '16px'
  }
}

export const Container = styled.div`
  width:100%;
  margin:0 auto;
  padding: 0 16px;
`

export const SkeletonCard = styled(Skeleton)`
  width: ${({ type }) => CARD_BOX_SIZES[type].width ?? 'inherit'};
  height: ${({ type }) => CARD_BOX_SIZES[type].height ?? 'inherit'};
  border-radius: ${({ type }) => CARD_BOX_SIZES[type].borderRadius ?? '0'};
  margin-bottom: ${({ type }) => CARD_BOX_SIZES[type].marginBottom ?? '0'};
`

export const CardContainer = styled.div`
  margin-bottom: 16px;
  width: 100%;
`

export const Block = styled.div`
  width: 100%;

  hr{
    margin-bottom: 0;
  }
`

export const BoxAlert = styled.div`
  margin-top: 16px;

  span {
    display: block;
  }
`

export const BlockFlex = styled.div`
  display: flex;
  flex-direction: column;
`

export const EarningsOfTheDay = styled.div`
  color: ${colors.cyan.default};
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.96px;
  margin-top: 16px;
  ${({ isDisabled }) => isDisabled && `
    color: ${colors.gray.darker};
  `}
`

export const Text = styled.p`
  font-family: 'Open Sans';
  font-weight: 400;
  font-size: 13px;
  line-height: 19px;
  margin: 0 0 8px 0;
  color: ${colors.gray.dark};
  ${({ isDisabled }) => isDisabled && `
    color: ${colors.gray.mediumDark};
  `}

  strong {
    font-family: 'Open Sans';
    font-weight: 600;
  }
`

export const TotalEarnings = styled.div`
  display: flex;
  padding: 6px 8px;
  background-color: ${colors.cyan.light};
  border-radius: 8px;
  width: fit-content;
  margin-top: 16px;
  font-family: 'Open Sans';
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 0px;
  color: ${colors.cyan.default};

`
export const LoadMoreButton = styled(CustomButton)`
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 600;
  line-height: 19px;
`
export const clientCampaigns = styled.span`
  padding-top: 17px;
  font-family: 'Open Sans';
`
